import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import QueueList from '../components/QueueList.vue'
import Queue from '../components/Queue.vue'
import Option from '../components/Option.vue'

Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: function () {
//       return import(/* webpackChunkName: "about" */ '../views/About.vue')
//     }
//   }
// ]

const routes = [
  {
    path: '/',
    name: 'QueueList',
    component: QueueList
  },
  {
    path: '/queue/:queue_id',
    name: 'Queue',
    component: Queue
  },
  {
    path: '/queue/:queue_id/option/:option_id',
    name: 'Option',
    component: Option,
    props: true
  }
]


const router = new VueRouter({
  routes
})

export default router
